import * as React from 'react';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import CircularProgress from '@mui/material/CircularProgress';
import { createFilterOptions } from '@material-ui/lab/Autocomplete';
import { makeStyles } from "@material-ui/core/styles";
import InputAdornment from '@mui/material/InputAdornment';
import SearchIcon from '@mui/icons-material/Search';

const useStyles = makeStyles({
    paper: {
      fontSize: '12px !important',    
    }
  });

  function sleep(delay = 0) {
    return new Promise((resolve) => {
      setTimeout(resolve, delay);
    });
  }

export default function Asynchronous(props) {
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);
  const [options, setOptions] = React.useState([]);
  const loading = open && options && options.length === 0;

  React.useEffect(() => {
    let active = true;

    if (!loading) {
      return undefined;
    }
    (async () => {
      await sleep(1e3); 
      if (active && props.options && props.options.length>0) {        
        setOptions(props.options);
      }
    })();

    return () => {
      active = false;
    };
  }, [props.options,loading]);

  React.useEffect(() => { //setApiData
    if (!open) {
      setOptions([]);
    }
  }, [open]);

  function selectedValue(obj){
    if(obj){
        props.toCallParentMethod(props.flag,obj);
    }    
  }

  const filterOptions = createFilterOptions({    
    matchFrom: 'start',
    stringify: option => option.title,
  });

  return (
    <>    
        <Autocomplete
          id="search-input-topicbox"
          freeSolo
          classes={{ paper: classes.paper }}          
          open={open}
          onOpen={() => {
            setOpen(true);
          }}
          onClose={() => {
            setOpen(false);
          }}
          isOptionEqualToValue={(option, value) => option.title === value.title}
          getOptionLabel={(option) => option.title}
          options={options}
          loading={loading}
          filterOptions={filterOptions}
          onChange={(event, myObj) => selectedValue(myObj)}          
          renderInput={(params) => (
            <TextField 
              {...params}
              label={props.label} 
              InputProps={{
                ...params.InputProps,
                endAdornment: (
                  <React.Fragment>
                    {loading ? <CircularProgress color="inherit" size={20} /> : null}
                    {params.InputProps.endAdornment}
                  </React.Fragment>
                ),
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon style={{marginLeft:6}} />
                  </InputAdornment>
                ),
                sx: { borderRadius: 10 }
              }}
              ///placeholder={props.label}
              size='small'
            />
          )}
        />
    </>
  );
}

